// Utility layer (TS-2.5.04) - pure, no side effects. Small formatting/lookup helpers shared by the
// decks feature's presentational components, kept out of those components so they stay testable
// without rendering anything.
import type { ArtifactFormat, ArtifactRef } from "../../../api/generated/contracts";

export function formatDate(isoDate: string): string {
  if (!isoDate) return "—";
  const parsed = new Date(isoDate);
  if (Number.isNaN(parsed.getTime())) return isoDate;
  return parsed.toLocaleDateString();
}

export function formatDateTime(isoDateTime: string): string {
  if (!isoDateTime) return "—";
  const parsed = new Date(isoDateTime);
  if (Number.isNaN(parsed.getTime())) return isoDateTime;
  return parsed.toLocaleString();
}

/** Finds the artifact of a given format on a version, if one has been produced yet (D-182: a
 * published version may carry a pptx with no pdf yet). */
export function artifactOfFormat(artifacts: readonly ArtifactRef[], format: ArtifactFormat): ArtifactRef | null {
  return artifacts.find((artifact) => artifact.format === format) ?? null;
}
